import React, { useEffect, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";

//components
import ManageTableWithDynamicPagination from "../../Components/TableTemplate/ManageTableWithDynamicPagination";
import Navbar from "../../Components/Navbar/Navbar";
import DeleteModal from "../../Components/Modals/DeleteModal";
import AddModal from "../../Components/Modals/AddModal";
import EditModal from "../../Components/Modals/EditModal";
import ViewModal from "../../Components/Modals/ViewModal";
import InputError from "../../Components/InputError/InputError";

//css
import "./Manage.css";
import "../../Components/Navbar/Navbar.css";

import {
    createForwarder,
    deleteForwarder,
    editForwarder,
    getAllForwarders,
    getForwarder,
    searchForwarder,
} from "../../Helpers/apiCalls/forwardersApi";
import { isAdmin, refreshPage, toastStyle } from "../../Helpers/Utils/Common";
import { validateForwarders } from "../../Helpers/Validation/Manage/ForwardersValidation";
import toast from "react-hot-toast";
import Footer from "../../Components/Footer/Footer";
import downloadIcon from "../../Assets/Images/download_icon.png";
import * as XLSX from "xlsx";

export default function Forwarders() {
    const [inactive, setInactive] = useState(false);
    const [showLoader, setShowLoader] = useState(false);
    const [isClicked, setIsClicked] = useState(false);
    const [excelData, setExcelData] = useState([]);
    const [filterConfig, setFilterConfig] = useState({
        page: 1,
    });
    const [totalItems, setTotalItems] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10; // Change this based on your requirement

    const handlePageChange = page => {
        setCurrentPage(page);
        setFilterConfig(prev => ({
        ...prev,
        page: page,
        }));
    };

    // MODALS //
    // DELETE
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const handleShowDeleteModal = () => setShowDeleteModal(true);
    const handleCloseDeleteModal = () => setShowDeleteModal(false);

    // VIEW
    const [showViewForwarderModal, setShowViewForwarderModal] = useState(false);
    const handleShowViewForwarderModal = () => setShowViewForwarderModal(true);
    const handleCloseViewForwarderModal = () =>
        setShowViewForwarderModal(false);

    // EDIT
    const [showEditForwarderModal, setShowEditForwarderModal] = useState(false);
    const handleShowEditForwarderModal = () => setShowEditForwarderModal(true);
    const handleCloseEditForwarderModal = () =>
        setShowEditForwarderModal(false);

    // ADD
    const [showAddForwarderModal, setShowAddForwarderModal] = useState(false);
    const handleShowAddForwarderModal = () => setShowAddForwarderModal(true);
    const handleCloseAddForwarderModal = () => setShowAddForwarderModal(false);

    //API
    const [forwardersData, setForwardersData] = useState([]);
    const [forwarderData, setForwarderData] = useState({});
    const [selectedID, setSelectedID] = useState("");
    const [forwarderDetails, setForwarderDetails] = useState({
        name: "",
        address: " ",
        phone_no: "",
    });

    //REQUIRED ERROR HANDLING
    const [isError, setIsError] = useState({
        name: false,
    });

    const [isErrorEdit, setIsErrorEdit] = useState({
        name: false,
    });
    
    const xlsxHeaders =  [
        "NAME",
        "ADDRESS"
    ]

    //EXPORT 
    function handleExport() {
        const rows = excelData
        
        /* generate worksheet and workbook */
        const worksheet = XLSX.utils.json_to_sheet(rows);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet 1");
        XLSX.utils.sheet_add_aoa(worksheet, [xlsxHeaders], { origin: "A1" });
        XLSX.writeFile(workbook, "Forwarders.xlsx", { compression: true });
    }

    //ONCHANGE
    //ADD or CREATE FORWARDER
    const handleAddChange = (e) => {
        const { name, value } = e.target;
        setForwarderDetails((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };
    //onEdit
    function handleOnEdit() {
        handleCloseViewForwarderModal();
        handleShowEditForwarderModal();
    }

    //EDIT OR UPDATE FORWARDER
    const handleEditChange = (e) => {
        const { name, value } = e.target;
        setForwarderData((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    //DELETE or REMOVE FORWARDER
    function handleDeleteForwarder() {
        removeForwarder(selectedID);
    }

    //DROPDOWN
    function handleSelectChange(e, row) {
        fetchForwarder(row.id);
        setSelectedID(row.id);
        if (e.target.value === "delete-forwarder") {
            handleShowDeleteModal();
        } else if (e.target.value === "edit-forwarder") {
            handleShowEditForwarderModal();
        } else if (e.target.value === "view-forwarder") {
            handleShowViewForwarderModal();
        } else {
            handleShowDeleteModal();
        }
    }

    function ActionBtn(row) {
        return (
            <Form.Select
                name="action"
                className="PO-select-action form-select"
                id={row.id}
                onChange={(e) => handleSelectChange(e, row)}
            >
                <option defaulValue selected hidden>
                    Select
                </option>
                <option value="view-forwarder" className="color-options">
                    View
                </option>
                {isAdmin && (
                    <option value="edit-forwarder" className="color-options">
                        Edit
                    </option>
                )}
                {isAdmin && (
                    <option value="delete-forwarder" className="color-red">
                        Delete
                    </option>
                )}
            </Form.Select>
        );
    }

    //API CALL
    async function fetchAllForwarders() {
        setShowLoader(true);
        const response = await getAllForwarders();
        console.log(response)
        if (response.data) {
            setForwardersData(response.data.data);
        } else {
            setForwardersData([]);
        }
        setShowLoader(false);
    }

    const [searchName, setSearchName] = useState("");

    // SEARCH USER
    function handleOnSearch(e) {
        setSearchName(e.target.value);
    }

    async function fetchSearchForwarder() {
        setTotalItems(0);
        setShowLoader(true);
        filterConfig.name = searchName
        const response = await searchForwarder(filterConfig);
        if (response.response) {
            var sortedData = response.response.data.sort((a, b) =>
                a.name > b.name
                    ? 1
                    : b.name > a.name
                    ? -1
                    : 0
            );
            sortedData.map((forwarder)=>{
                return{
                    name: forwarder.name,
                }
            })
            setForwardersData(sortedData);
            setTotalItems(response.response.size)

            var excel = sortedData.map((data) => {
                var info = {};
                info.name = data.name
                info.address = data.address
                return info;
            });
            setExcelData(excel)
        } else {
            setForwardersData([]);
        }
        setShowLoader(false);
    }

    async function fetchForwarder(id) {
        const response = await getForwarder(id);
        if (response.data.data) {
            var forwarder = response.data.data[0];
            setForwarderData(forwarder);
        } else {
            setForwarderData({});
        }
    }

    async function handleSaveForwarder() {
        if (validateForwarders(forwarderDetails, setIsError)) {
            setIsClicked(true);

            const response = await createForwarder(forwarderDetails);
            if (response.data) {
                toast.success("Successfully created forwarder!", {
                    style: toastStyle(),
                });
                handleCloseAddForwarderModal();
                refreshPage();
            } else {
                toast.error(response.error.data.messages.error, {
                    style: toastStyle(),
                });
            }
        } else {
            toast.error("Please fill in all fields!", { style: toastStyle() });
        }
    }

    async function handleEditForwarder() {
        if (validateForwarders(forwarderData, setIsErrorEdit)) {
            setIsClicked(true);
            const response = await editForwarder(forwarderData);
            if (response.data) {
                toast.success("Successfully updated forwarder!", {
                    style: toastStyle(),
                });
                handleCloseEditForwarderModal();
                refreshPage();
            } else {
                toast.error(response.error.data.messages.error, {
                    style: toastStyle(),
                });
            }
        } else {
            toast.error("Please fill in all fields!", { style: toastStyle() });
        }
    }

    async function removeForwarder(id) {
        setIsClicked(true);
        const response = await deleteForwarder(id);
        if (response.data) {
            toast.success("Successfully deleted forwarder!", {
                style: toastStyle(),
            });
            handleCloseDeleteModal();
            refreshPage();
        } else {
            toast.error(response.error.data.messages.error, {
                style: toastStyle(),
            });
        }
    }

    useEffect(() => {
        fetchAllForwarders();
    }, [currentPage]);

    useEffect(() => {
        fetchSearchForwarder();
    }, [searchName, currentPage]);

    return (
        <div>
            <div className="page">
                <Navbar
                    onCollapse={(inactive) => {
                        setInactive(inactive);
                    }}
                    active={"MANAGE"}
                />
            </div>
            <div
                className={`manager-container ${
                    inactive ? "inactive" : "active"
                }`}
            >
                <Row className="mb-4">
                    <Col xs={12} lg={7}>
                        <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2"> FORWARDERS </h1>
                    </Col>
                    <Col xs={12} lg={3} className="d-flex justify-content-end force-width flex-column flex-lg-row gap-3">
                        <input
                            type="search"
                            className="search-bar"
                            defaultValue=""
                            placeholder="Search name..."
                            // onChange={(e) => handleOnSearch(e)}
                            onKeyPress={(e) =>
                                e.key === ("Enter" || "NumpadEnter") &&
                                handleOnSearch(e)
                            }
                        />
                    </Col>
                    <Col lg={2} className="mt-4 mt-lg-0">
                        <div className="PO-filters">
                        <button
                            className="add-btn"
                            onClick={handleShowAddForwarderModal}
                        >
                            Add
                        </button>
                        </div>
                    </Col>
                </Row>
                <div className="tab-content">
                    {/* TABLE */}
                    <ManageTableWithDynamicPagination
                        tableHeaders={["NAME", "ADDRESS", "CONTACT PERSON", "CONTACT NO.", "ACTIONS"]}
                        headerSelector={["name", "address", "contact_person", "phone_no"]}
                        tableData={forwardersData}
                        ActionBtn={(row) => ActionBtn(row)}
                        showLoader={showLoader}
                        // used in dynamic pagination
                        totalItems={totalItems}
                        currentPage={currentPage}
                        itemsPerPage={itemsPerPage}
                        handlePageChange={handlePageChange}
                    />
                </div>
                <div className="mb-3" />
                <Row>
                    <Col lg={10} className="mt-3 mt-lg-0"></Col>
                    <Col lg={2} className="mt-3 mt-lg-0">
                    <div className="PO-filters">
                        <button
                            type="button"
                            className="primary-btn"
                            onClick={handleExport}
                        >
                            <span className="me-2">
                                <img
                                    width={20}
                                    height={20}
                                    src={downloadIcon} alt=""
                                ></img>
                            </span>
                            Download
                        </button>
                    </div>
                    </Col>
                </Row>
                <div className="mb-3" />
                <br /><br />
            </div>

            {/* MODALS */}
            <DeleteModal
                text="forwarder"
                show={showDeleteModal}
                onHide={handleCloseDeleteModal}
                onDelete={handleDeleteForwarder}
                isClicked={isClicked}
            />
            <AddModal
                title="FORWARDER"
                size="lg"
                type="forwarder"
                show={showAddForwarderModal}
                onHide={handleCloseAddForwarderModal}
                onSave={handleSaveForwarder}
                isClicked={isClicked}
            >
                <div className="mt-3">
                    <Row className="nc-modal-custom-row mt-0">
                        <Col xs={12} lg={6}>
                            NAME
                            <span className="required-icon">*</span>
                            <Form.Control
                                type="text"
                                name="name"
                                className="nc-modal-custom-input"
                                onChange={(e) => handleAddChange(e)}
                                required
                            />
                            <InputError
                                isValid={isError.name}
                                message={"Name is required"}
                            />
                        </Col>
                        <Col xs={12} lg={6} className="mt-2 mt-lg-0">
                            PHONE NUMBER
                            <Form.Control
                                type="text"
                                name="phone_no"
                                className="nc-modal-custom-input"
                                onChange={(e) => handleAddChange(e)}
                                required
                            />
                        </Col>
                    </Row>
                    <Row className="nc-modal-custom-row">
                        <Col xs={12} lg={6} className="mt-2 mt-lg-0">
                            CONTACT PERSON
                            <Form.Control
                                type="text"
                                name="contact_person"
                                className="nc-modal-custom-input"
                                onChange={(e) => handleAddChange(e)}
                                required
                            />
                        </Col>
                        <Col xs={12} lg={6} className="mt-2 mt-lg-0">
                            ADDRESS
                            <Form.Control
                                type="text"
                                name="address"
                                className="nc-modal-custom-input"
                                onChange={(e) => handleAddChange(e)}
                                required
                            />
                        </Col>
                    </Row>
                </div>
            </AddModal>
            <EditModal
                title="FORWARDER"
                size="lg"
                type="forwarder"
                show={showEditForwarderModal}
                onHide={handleCloseEditForwarderModal}
                onSave={handleEditForwarder}
                isClicked={isClicked}
            >
                <div className="mt-3">
                    <Row className="nc-modal-custom-row mt-0">
                        <Col xs={12} lg={6}>
                            NAME
                            <Form.Control
                                type="text"
                                name="name"
                                defaultValue={forwarderData.name}
                                className="nc-modal-custom-input-edit"
                                onChange={(e) => handleEditChange(e)}
                                required
                            />
                            <InputError
                                isValid={isErrorEdit.name}
                                message={"Name is required"}
                            />
                        </Col>
                        <Col xs={12} lg={6} className="mt-2 mt-lg-0">
                            PHONE NUMBER
                            <Form.Control
                                type="text"
                                name="phone_no"
                                defaultValue={forwarderData.phone_no}
                                className="nc-modal-custom-input-edit"
                                onChange={(e) => handleEditChange(e)}
                                required
                            />
                        </Col>
                    </Row>
                    <Row className="nc-modal-custom-row">
                        <Col xs={12} lg={6} className="mt-2 mt-lg-0">
                            CONTACT PERSON
                            <Form.Control
                                type="text"
                                name="contact_person"
                                defaultValue={forwarderData.contact_person}
                                className="nc-modal-custom-input-edit"
                                onChange={(e) => handleEditChange(e)}
                                required
                            />
                        </Col>
                        <Col xs={12} lg={6} className="mt-2 mt-lg-0">
                            ADDRESS
                            <Form.Control
                                type="text"
                                name="address"
                                defaultValue={forwarderData.address}
                                className="nc-modal-custom-input-edit"
                                onChange={(e) => handleEditChange(e)}
                                required
                            />
                        </Col>
                    </Row>
                </div>
            </EditModal>
            <ViewModal
                withButtons
                show={showViewForwarderModal}
                onHide={handleCloseViewForwarderModal}
                onEdit={handleOnEdit}
            >
                <div>
                    <div className="col-sm-12 space">
                        <span className="custom-modal-body-title-forwarder-details">
                            FORWARDER DETAILS
                        </span>
                        <div className="container-wrapper">
                            <Row className="nc-modal-custom-row-view">
                                <Col xs={12} lg={6} className="nc-modal-custom-row-details mb-2 mb-lg-0">
                                    NAME
                                    <Row className="nc-modal-custom-row">
                                        <Col> {forwarderData.name}</Col>
                                    </Row>
                                </Col>
                                <Col xs={12} lg={6} className="nc-modal-custom-row-details">
                                    PHONE NUMBER
                                    <Row className="nc-modal-custom-row">
                                        <Col>{forwarderData.phone_no} </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Row className="nc-modal-custom-row-view mt-3">
                                <Col xs={12} lg={6} className="nc-modal-custom-row-details mb-2 mb-lg-0">
                                    CONTACT PERSON
                                    <Row className="nc-modal-custom-row">
                                        <Col>{forwarderData.contact_person}</Col>
                                    </Row>
                                </Col>
                                <Col xs={12} lg={6} className="nc-modal-custom-row-details">
                                    ADDRESS
                                    <Row className="nc-modal-custom-row">
                                        <Col>{forwarderData.address}</Col>
                                    </Row>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </div>
            </ViewModal>
            <Footer/>
        </div>
    );
}
